import { globals } from '@/src/globals'

const manageButtonVisibility = (electroReferenceSingleElement: HTMLElement): void => {
  // If element is already opened, ignore this and skip the rest of the function
  if (electroReferenceSingleElement.classList.contains('-opened')) {
    return
  }

  const innerElement = electroReferenceSingleElement.querySelector('.js-electroReferencesList-singleInner') as HTMLElement

  const wrapperDefaultHeight: number = electroReferenceSingleElement.offsetHeight

  const innerElementHeight: number = innerElement.offsetHeight

  // Remove the "Show more" trigger if the inner element is shorter or equal to the wrapper
  if (wrapperDefaultHeight >= innerElementHeight) {
    electroReferenceSingleElement.classList.remove('-showTrigger')
  }
  // Otherwise, add the "Show more" trigger
  else {
    electroReferenceSingleElement.classList.add('-showTrigger')
  }
}

const manageExpandSingle = (electroReferenceSingleElement: HTMLElement): void => {
  const triggerElement = electroReferenceSingleElement.querySelector('.js-electroReferencesList-singleShowMore') as HTMLElement

  triggerElement.addEventListener('click', () => {
    electroReferenceSingleElement.classList.add('-opened')

    // Trigger resize to recalculate "Show more" buttons on electro-references
    window.dispatchEvent(new Event('resize'))

    // Recalculate all masonrys on the page due to the display change
    globals.masonryList.forEach((masonry: any) => {
      masonry.layout()
    })
  })
}

const manageShrinkSingle = (electroReferenceSingleElement: HTMLElement): void => {
  const triggerElement = electroReferenceSingleElement.querySelector('.js-electroReferencesList-singleShowLess') as HTMLElement

  triggerElement.addEventListener('click', () => {
    electroReferenceSingleElement.classList.remove('-opened')

    // Trigger resize to recalculate "Show less" buttons on electro-references
    window.dispatchEvent(new Event('resize'))

    // Recalculate all masonrys on the page due to the display change
    globals.masonryList.forEach((masonry: any) => {
      masonry.layout()
    })
  })
}

export const electroReferencesShowMoreManager = (): void => {
  const allElectroReferenceBlocks = document.querySelectorAll('.js-electroReferencesList') as unknown as HTMLElement[]

  allElectroReferenceBlocks.forEach((electroReferenceBlock: HTMLElement) => {
    const electroReferenceSingleElements = electroReferenceBlock.querySelectorAll('.js-electroReferencesList-single') as unknown as HTMLElement[]

    electroReferenceSingleElements.forEach((single: HTMLElement) => {
      // Run once on start-up
      manageButtonVisibility(single)
      manageExpandSingle(single)
      manageShrinkSingle(single)

      // Run on resize
      window.addEventListener('resize', () => {
        manageButtonVisibility(single)
      })
    })
  })
}
